<!--文献下载侧边栏-->
<template>
	<div class="literature-box" >
	  <div>
	    <div class="literature-title" align="center">资料下载</div>
	    <div class="literature-list-item" v-for="item in typeList" @click="goNext(item.id)">{{item.type}}</div>
	  </div>
	</div>


  
</template>

<script>
  export default {
    data() {
      return {
      typeList:[],

      };
    },

    components: {},

    mounted() {
      this.getTypeList()
    },

    methods: {
      getTypeList() {
        this.instance.get('/api/data/gettypelist').then(res => {
          if (res.status == 200) {
            console.log('data', res.data)
            this.typeList = res.data.typelist
          }
        })
      },

      goNext(id) {
        this.$router.push({path:'/literature',query: {id:id}})
      },
    },

  }

</script>
<style scoped>
  .literature-box{
    position: relative;
    width: 100%;
    height: 100%;
    background: hsla(0, 0%, 100%, .2);
    border: 0.1vw solid rgb(60, 74, 93, .2);
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
    cursor:pointer;
  }



  .literature-title{
    height: 4vw;
    font-size: 1.2vw;
    font-weight: bold;
    color: #3C4A5D;
    /* text-align: center; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 0.15vw solid rgba(60,74,93,0.4);
  }
  .literature-list-item{
    height: 4vw;
    width: 100%;
    font-size: 0.9vw;
    font-weight: bold;
    color: #3C4A5D;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid blue; */
  }

  .literature-list-item:hover{

    background-color: rgba(254,232,166,0.4);
  }


</style>



// WEBPACK FOOTER //
// src/components/LiteratureAside.vue